import { render, staticRenderFns } from "./GroupFansDialog.vue?vue&type=template&id=87caa952&scoped=true"
import script from "./GroupFansDialog.vue?vue&type=script&lang=js"
export * from "./GroupFansDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupFansDialog.vue?vue&type=style&index=0&id=87caa952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87caa952",
  null
  
)

export default component.exports